import React from "react";
import { connect } from "react-redux";

import {Dialog} from 'primereact/dialog';

import * as appActionCreators from "../../actionCreators/app";

// destructure props so we only get the things we need
// error display in it's own component because it needs to connect to the store but
// issues are caused when that is attempted in the App container

// errorCount is being used in case there are a large number of errors so we don't flood the screen with them
// and so we don't accidently change a flag to the wrong state
const ErrorDisplay = ({ app, clearErrors }) =>
    <Dialog closable={true} visible={app.errorCount > 0}  modal={true} className={"error-modal"}
            onHide={(e) => clearErrors()}>
        An error occurred
    </Dialog>

const mapStateToProps=(state)=>{
    return state
}

export default connect (mapStateToProps, appActionCreators)(ErrorDisplay);


// WEBPACK FOOTER //
// ./src/components/common/ErrorDisplay.js